/**
 * DEV-1771 (эпик DEV-1766). i18n аналитики обучения: вкладка карточки агента и
 * сводка в управлении агентами. Overlay-модуль поверх базовых локалей — как
 * presentationsAnalytics, чтобы не раздувать монолитные ru/en/vn.
 */
export const agentEducationMessages = {
  ru: {
    agentsRegistry: {
      tabs2: { education: 'Обучение' },
      education: {
        summary: '{done} из {total} пройдено',
        colVideo: 'Видео',
        colProgress: 'Просмотрено',
        colStatus: 'Статус',
        colLastWatched: 'Последний просмотр',
        statusCompleted: 'Пройдено',
        statusInProgress: 'В процессе',
        statusNotStarted: 'Не начато',
        never: 'не смотрел',
        empty: 'Обучающих видео пока нет',
        emptyDescription: 'Ролики появятся здесь, когда их опубликуют в кабинете агента.',
      },
    },
    agentsAdmin: {
      tabs: { registry: 'Реестр', education: 'Обучение' },
      education: {
        title: 'Просмотр обучающих видео',
        subtitle: 'Сколько агентов начали и досмотрели каждую стратегию',
        colVideo: 'Видео',
        colStarted: 'Начали',
        colCompleted: 'Досмотрели',
        colRate: 'Доля досмотра',
        curveTitle: 'Кривая удержания',
        curveSubtitle: 'Доля начавших, которые ещё смотрят на этой секунде',
        curveAxisTime: 'Секунда ролика',
        curveEmpty: 'Кривая появится, когда ролики начнут смотреть',
        empty: 'Данных пока нет',
        emptyDescription: 'Сводка заполнится, как только агенты начнут смотреть видео.',
      },
    },
  },
  en: {
    agentsRegistry: {
      tabs2: { education: 'Training' },
      education: {
        summary: '{done} of {total} completed',
        colVideo: 'Video',
        colProgress: 'Watched',
        colStatus: 'Status',
        colLastWatched: 'Last watched',
        statusCompleted: 'Completed',
        statusInProgress: 'In progress',
        statusNotStarted: 'Not started',
        never: 'never watched',
        empty: 'No training videos yet',
        emptyDescription: 'Videos will appear here once they are published in the agent cabinet.',
      },
    },
    agentsAdmin: {
      tabs: { registry: 'Registry', education: 'Training' },
      education: {
        title: 'Training video watch-through',
        subtitle: 'How many agents started and finished each strategy',
        colVideo: 'Video',
        colStarted: 'Started',
        colCompleted: 'Finished',
        colRate: 'Completion rate',
        curveTitle: 'Retention curve',
        curveSubtitle: 'Share of starters still watching at each mark',
        curveAxisTime: 'Second of the video',
        curveEmpty: 'The curve appears once agents start watching',
        empty: 'No data yet',
        emptyDescription: 'The summary fills in as soon as agents start watching.',
      },
    },
  },
  vn: {
    agentsRegistry: {
      tabs2: { education: 'Đào tạo' },
      education: {
        summary: 'Đã hoàn thành {done}/{total}',
        colVideo: 'Video',
        colProgress: 'Đã xem',
        colStatus: 'Trạng thái',
        colLastWatched: 'Lần xem gần nhất',
        statusCompleted: 'Đã hoàn thành',
        statusInProgress: 'Đang xem',
        statusNotStarted: 'Chưa bắt đầu',
        never: 'chưa xem',
        empty: 'Chưa có video đào tạo',
        emptyDescription: 'Video sẽ xuất hiện khi được đăng trong cổng đại lý.',
      },
    },
    agentsAdmin: {
      tabs: { registry: 'Danh sách', education: 'Đào tạo' },
      education: {
        title: 'Mức độ xem video đào tạo',
        subtitle: 'Bao nhiêu đại lý đã bắt đầu và xem hết từng chiến lược',
        colVideo: 'Video',
        colStarted: 'Đã bắt đầu',
        colCompleted: 'Đã xem hết',
        colRate: 'Tỷ lệ xem hết',
        curveTitle: 'Đường giữ chân',
        curveSubtitle: 'Tỷ lệ người bắt đầu còn xem tại mỗi mốc',
        curveAxisTime: 'Giây của video',
        curveEmpty: 'Đường cong xuất hiện khi đại lý bắt đầu xem',
        empty: 'Chưa có dữ liệu',
        emptyDescription: 'Bảng tổng hợp sẽ có dữ liệu ngay khi đại lý bắt đầu xem.',
      },
    },
  },
}
